<template>
    <a v-if="href == null || href==={}">
        <slot></slot>
    </a>
    <router-link v-else :to="href">
        <slot></slot>
    </router-link>
</template>

<script>
    export default {
        name: 'CustomLink',
        components: {
        },
        //@click="clickEvent"
        props: {
            href: {type:[String, Object],default:null}
        },
        methods: {
            onClick(event) { this.$emit("click", event); }
        }
    };
</script>

<style>
    .actions button, button {
        /* color: white; */
        border-radius: 100px!Important;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.7px;
        line-height: 13px;
        text-align: center;
        padding: 9px 15px;
        cursor: pointer;
    }
</style>
